import UpdatePrd from './UpdatePrd';

export default UpdatePrd;